/* List of Playwright data-testid attributes strings */

import type { SearchResultType } from '@framework/constants/enums/globalSearch';

// navigations
export const APP_HEADER = 'app_header';
export const APP_HEADER_ROOMS_TITLE = 'rooms_title';
export const APP_HEADER_AVATAR = 'avatar_icon';
export const APP_SIDE_MENU = 'app_side_menu';
export const BACK_BUTTON = 'back_button';
export const BULK_ACTIONS_CONTAINER = 'bulk_actions_container';
export const BULK_ACTIONS_BAR = 'bulk_actions_bar';
export const ADMIN_PORTAL_TILE = 'admin_portal_tile';
export const COMMENT_BOX = 'comment_box';
export const PROGRESS_BAR = 'progress_bar';
export const NOTIFICATIONS = 'notifications';
export const DOT_NEUTRAL = 'dot_icon_neutral';
export const ICON_SUCCESS = 'icon_success';
export const ICON_ERROR = 'icon_error';
export const EDIT_MODE_SWITCH = 'switch_to_edit_mode';
export const VIEW_MODE_SWITCH = 'switch_to_view_mode';
export const COLLAPSE_ICON = 'collapse_icon';
export const COLLAPSE_BAR = 'collapse_bar';
export const ROOM_SELECT_TRIGGER = 'room_select_trigger';
export const USER_MENU_LIST = 'user_menu_list';
export const USER_MENU_AVATAR = 'user_menu_avatar';
export const ROOM_SELECT_LIST = 'room_select_list';
export const ROOM_SELECT_LIST_ITEM = 'room_select_list_item';
export const ROOM_SELECT_ACTIVE_ITEM = 'room_select_active_item';
export const GIVE_ACCESS_LOADING = 'give_access_loading';
export const LIBRARY_CORPORATE_SEGMENTED_TAB_BUTTON = 'corporate_segmented_tab_button';
export const LIBRARY_PRIVATE_SEGMENTED_TAB_BUTTON = 'private_segmented_tab_button';
export const USER_MANAGEMENT_MEMBERS_SEGMENTED_TAB_BUTTON = 'members_segmented_tab_button';
export const USER_MANAGEMENT_GROUPS_SEGMENTED_TAB_BUTTON = 'groups_segmented_tab_button';
export const TASKS_DECISIONS_TASKS_SEGMENTED_TAB_BUTTON = 'tasks_segmented_tab_button';
export const TASKS_DECISIONS_DECISIONS_SEGMENTED_TAB_BUTTON = 'decisions_segmented_tab_button';

// support
export const GIVE_ACCESS_CSM_SELECT = 'csm_select';
export const GIVE_ACCESS_TIME_SELECT = 'time_select';

// settings
export const SETTINGS_ITEM = 'settings_item';
export const SETTINGS_PROFILE_SAVE = 'save_user_profile';
export const SETTINGS_PROFILE_CLOSE = 'close_user_profile';
export const SETTINGS_PROFILE_EDIT = 'edit_user_profile';
export const SETTINGS_AMBASSADOR_SWITCH = 'switch_user_settings';

// details
export const GENERAL_DETAILS_PANEL = 'details_panel';
export const GENERAL_MODAL_DELETE_CONFIRM = 'confirm_delete_modal';
export const CONFIRM_DELETE_BUTTON = 'confirm_delete_button';
export const CUSTOM_INVITATION = 'customInvitation';
export const MEMBERS_DETAILS_PANEL = 'member_details_panel';
export const MEMBERS_DETAILS_SAVE = 'member_details_save';
export const MEMBERS_DETAILS_EDIT = 'member_details_edit';
export const MEMBERS_DETAILS_DELETE = 'member_details_delete';
export const MEMBERS_DETAILS_MEMBER_NAME = 'member_details_member_name';
export const MEMBERS_FORM_PANEL = 'member_form_panel';
export const MEMBERS_ADD_MEMBER_SIDE_PANEL_PORTAL = 'add_member_side_panel_portal';
export const MEMBERS_FORM_GROUPS_PICKER = 'member_form_groups_picker';
export const MEMBERS_FILTERS = 'members_filters';
export const MEMBER_FORM_PERMISSIONS_STEP = 'member_form_permissions_step';
export const TIMEZONE_LIST = 'timezone_list';
export const ADD_PEOPLE_INPUT = 'add_people_input_field';
export const MEETING_ACTIONS_CONTAINER = 'meeting_actions_container';
export const MORE_ACTIONS_MENU = 'more_actions_menu';
export const MORE_ACTIONS_MENU_MEETING_HISTORY = 'more_actions_menu_history';
export const MORE_ACTIONS_MENU_DELETE = 'more_actions_menu_delete';
export const MORE_ACTIONS_MENU_CREATE_TEMPLATE = 'more_actions_menu_create_template';
export const MORE_ACTIONS_MENU_DOCUMENT_SECURITY_SETTINGS =
    'more_actions_menu_document_security_settings';
export const MORE_ACTIONS_MENU_LOCK_UNLOCK_MEETING = 'more_actions_menu_lock_unlock_meeting';
export const MEMBERS_ROW = 'group_members_row';
export const GROUP_MANAGERS_LIST = 'group_managers_list';
export const ADD_MEMBERS_TO_GROUP_SEARCH = 'add_members_to_group_search';
export const ADD_MEMBERS_ROW = 'add_member_row';
export const ADD_MEMBERS_TO_GROUP_BUTTON = 'add_members_to_group_button';
export const START_TIME_PICKER = 'start_time';
export const END_TIME_PICKER = 'end_time';
export const DATE_PICKER = 'date_picker';
export const MEETING_LEADER_SECTION = 'meeting_leader_section';
export const MEETING_LEADER_ACTION_MENU_BUTTON = 'meeting_leader_action_button';
export const MEETING_LEADER_SELECTOR = 'meeting_leader_selector';
export const OPEN_MEETING_LEADER_MODAL_BUTTON = 'open_meeting_leader_modal_button';
export const MEETING_PARTICIPANT_ACTION_MENU_BUTTON = 'meeting_participant_action_menu_button';
export const MEETING_PARTICIPANT_ACTION_MENU = 'meeting_participant_action_menu';
export const AGENDA_ACCESS_ICON = 'agenda_access_icon';
export const GUEST_ACCESS_ICON = 'guest_access_icon';
export const AGENDA_ACCESS_WARNING = 'agenda_access_warning';
export const MANAGE_AGENDA_ACCESS_BUTTON_ON_DETAILS = 'manage_agenda_access_button';
export const AGENDA_ACCESS_LIST = 'agenda_access_list';
export const OPEN_INVITE_GUEST_MODAL_VIA_MENU_BUTTON = 'open_invite_guest_modal_via_menu_button';
export const OPEN_INVITE_GUEST_MODAL_VIA_SEARCH = 'open_invite_guest_modal_via_search';
export const OPEN_INVITE_MINUTES_VIEWER_MODAL_VIA_MENU_BUTTON =
    'open_invite_minutes_viewer_modal_via_menu_button';
export const OPEN_INVITE_MINUTES_VIEWER_MODAL_VIA_SEARCH =
    'open_invite_minutes_viewer_modal_via_search';
export const ADD_EXISTING_PERSON_AS_GUEST = 'add_existing_person_as_guest';
export const GO_TO_THIS_PERSON = 'go_to_this_person';
export const CLONE_MEETING_BUTTON = 'clone_meeting_button';
export const ASSISTANTS_SECTION = 'assistants_section';
export const ASSISTANTS_LIST = 'assistants_list';
export const ASSISTANT_PICKER = 'assistant_picker';
export const ASSISTANT_PICKER_DROPDOWN_MENU = 'assistant_picker_dropdown_menu';
export const ASSISTANT_LIST_ROW = (name: string) => `assistant_list_row: ${name}`;
export const ASSISTANT_REMOVE_BUTTON = 'remove_assistant_button';
export const ASSISTANT_PREVIEW_BUTTON = 'preview_assistant_button';
export const MEETING_DETAILS_TOP_BAR = 'meeting_details_top_bar';
export const OPEN_SEND_EMAIL_MODAL = 'open_send_email_modal';
export const SEND_EMAIL_MODAL_SELECT_ALL_MINUTES_VIEWERS =
    'send_email_modal_select_all_minutes_viewers';
export const INVITATION_FILE_UPLOADER = 'invitation-file-uploader';
export const CUSTOM_INVITATION_PREVIEW = 'custom_invitation_preview';
export const CUSTOM_INVITATION_ACTIONS = 'custom_invitation_actions';
export const CREATE_MEETING_BUTTON = 'create_meeting_button';
export const UPDATE_MEETING_BUTTON = 'update_meeting_button';
export const CANCEL_MEETING_BUTTON = 'cancel_meeting_button';
export const INVITATION_UPLOAD_STATUS_BAR = 'invitation_upload_status_bar';
export const INVITATION_ACTIONS = 'invitation_actions';
export const SHARE_MEETING_ACTION_BUTTON = 'share_meeting_action_button';
export const NOTIFY_MEETING_ACTION_BUTTON = 'notify_meeting_action_button';
export const CLONE_MEETING_ACTION_BUTTON = 'clone_meeting_action_button';
export const OPEN_APPROVAL_MODAL_BUTTON = 'open_approval_modal_button';

// meeting view mode
export const JOIN_CALL_OVERVIEW_BUTTON = 'join_call_overview_button';
export const POINTER_SPOTLIGHT = 'pointer_spotlight';
export const MEETING_DATE_TIME = 'meeting_date_time';
export const PARTIAL_MEETING_DATE_TIME = 'partial_meeting_date_time';
export const MEETING_VIEW_AGENDA_ITEM_CARD = 'meeting_view_agenda_item_card';

// meeting preparedness
export const PERSONAL_MEETING_PREPAREDNESS_LEVEL = 'personal_meeting_preparedness_level';
export const OVERALL_MEETING_PREPAREDNESS_LEVEL = 'overall_meeting_preparedness_level';
export const OPEN_MEETING_PREPAREDNESS_SETTINGS_MODAL = 'open_meeting_preparedness_settings_modal';
export const SHOW_COMPLETED_TOGGLE = 'show_completed_toggle';
export const SEND_REMINDER_EDITOR = 'send_reminder_editor';
export const NOTHING_TO_PREPARE = 'nothing_to_prepare';
export const COMPLETED_PREPARATION = 'completed_preparation';

// meeting history
export const LIST_ELEMENT_HISTORY_ROW = 'list_element_history_row';
export const LIST_ELEMENT_HISTORY_DATE = 'list_element_history_date';
export const LIST_ELEMENT_HISTORY_USER = 'list_element_history_user';
export const LIST_ELEMENT_HISTORY_TITLE = 'list_element_history_title';
export const LIST_ELEMENT_HISTORY_TYPE = 'list_element_history_type';
export const LIST_ELEMENT_HISTORY_DESCRIPTION = 'list_element_history_description';
export const TOGGLE_EXPAND_BUTTON = 'toggle_expand_button';

// minutes editor
export const MINUTES_EDITOR_STATUS = 'minutes_editor_status';
export const MINUTES_EDITOR_ADD_TEXT_BLOCK = 'add_text_block';
export const MINUTES_EDITOR_LAYOUT = 'minutes_editor_layout';
export const MINUTES_EDITOR_CONTAINER = 'minutes_editor_container';
export const MINUTES_EDITOR_TOP_BAR = 'minutes_editor_top_bar';
export const MINUTES_EDITOR_SAVED_STATUS = 'minutes_editor_saved_status';
export const MINUTES_EDITOR_PAGE = 'minutes_editor_page';
export const MINUTES_EDITOR_AGENDA_ITEM = 'minutes_editor_agenda_item';
export const MINUTES_EDITOR_DOCUMENT_ITEM = 'minutes_editor_document_item';
export const MINUTES_EDITOR_PAGE_MAIN_CONTENT = 'minutes_editor_page_main_content';
export const MINUTES_EDITOR_TASKS_ITEM = 'minutes_editor_tasks_item';
export const MINUTES_EDITOR_DECISIONS_ITEM = 'minutes_editor_decisions_item';

// agenda
export const TYPE_NEW_AGENDA_ITEM = 'type_new_agenda_item';
export const SAVE_AGENDA_ITEM = 'save_agenda_item';
export const CANCEL_AGENDA_ITEM = 'cancel_agenda_item';
export const ACCESS_GROUPS_SECTION_HEADER = 'access_groups_section_header';
export const ACCESS_GUESTS_SECTION_HEADER = 'access_guests_section_header';
export const ACCESS_NONPARTICIPANTS_SECTION_HEADER = 'access_nonparticipants_section_header';
export const ACCESS_PARTICIPANTS_SECTION_HEADER = 'access_participants_section_header';
export const AGENDA_CONTRIBUTOR_ROW = 'agenda_contributor_row';
export const AGENDA_CONTRIBUTION_ACTIONS_MENU = 'agenda_contribution_actions_menu';
export const AGENDA_EXCLUSION_ICON = 'manage_access_with_exclusion_icon';
export const AGENDA_MANAGE_ACCESS = 'manage_access';
export const AGENDA_ITEM_TYPE = 'agenda_item_type';
export const AGENDA_TYPE = 'agenda_type';
export const AGENDA_ITEM_EXPAND_COLLAPSE = 'agenda_item_expand_collapse';
export const AGENDA_ITEM_ROW = 'agenda_item_row';
export const AGENDA_ITEM_NUMBER = 'agenda_item_number';
export const AGENDA_DOCUMENT_MORE_MENU = 'document_more_menu';
export const AGENDA_EXTERNAL_CONTENT_MORE_MENU = 'external_content_more_menu';
export const ISOM_AGENDA_STATUS = 'isom_agenda_status';
export const AGENDA_ITEM_TITLE = 'agenda_item_title';
export const AGENDA_ITEM_DESCRIPTION = 'contenteditable-remarks';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL = 'agenda_item_classification_level';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL_INTERNAL = 'internal';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL_CONFIDENTIAL = 'confidential';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL_SECRET = 'secret';
export const AGENDA_ITEM_GUESTS = 'agenda_item_guests';
export const AGENDA_ITEM_NAME = 'agenda_item_name';
export const AGENDA_ITEM_NAME_INPUT = 'agenda_item_name_input';
export const AGENDA_DURATION_TIME = 'agenda_item_duration';
export const AGENDA_UNPUBLISHED = 'unpublished_change';
export const CANCEL_VOTE = 'cancel_vote';
export const CHANGE_VOTE = 'change_vote';
export const EDIT_DOCUMENT_BUTTON = 'edit_document_button';
export const SAVE_VOTE = 'save_vote';
export const NEXT_BUTTON_VOTE_SET_UP_MODAL = 'next_button_vote_set_up_modal';
export const SAVE_SET_UP_VOTE = 'save_set_up_vote';
export const VOTE = 'vote';
export const VOTE_ABSTAIN = 'vote_abstain';
export const VOTE_CONTAINER = 'vote_container';
export const VOTE_NO = 'vote_no';
export const VOTE_REQUEST_DISCUSSION = 'vote_request_discussion';
export const VOTE_YES = 'vote_yes';
export const VOTING_AGENDA_ITEM_TITLE = 'voting_agenda_item_title';
export const SET_UP_A_VOTE_MODAL = 'setup_a_vote_modal';
export const VOTING_YES_ICON = 'voting_yes_icon';
export const VOTING_NO_ICON = 'voting_no_icon';
export const VOTING_ABSTAIN_ICON = 'voting_abstain_icon';
export const VOTING_DISCUSSION_ICON = 'voting_discussion_icon';
export const VOTING_PENDING_ICON = 'voting_pending_icon';
export const EXTERNAL_LINK_ICON = 'external_link_icon';
export const ISOM_SHARE_DRAFT_INPUT = 'share_draft_search_input';
export const ATTACHABLE_CHECKBOX = 'attachable-checkbox';
export const AGENDA_PDF_DOWNLOAD = 'agendaPDF-download-button';
export const MEETING_BOOK_PDF_DOWNLOAD = 'meetingBookPDF-download-button';
export const AGENDA_MORE_ACTIONS_MENU = 'agenda_more_actions_menu';
export const AGENDA_MORE_ACTIONS_MENU_BUTTON = 'agenda_more_actions_menu_button';
export const OPEN_ADD_GUESTS_MODAL = 'open_add_guests_modal';
export const ADD_GUESTS_SELECTOR = 'add_guests_selector';
export const ADD_GUESTS_SAVE_BUTTON = 'add_guests_save_button';
export const ADD_GUESTS_CANCEL_BUTTON = 'add_guests_cancel_button';
export const GUEST_AGENDA_ACCESS_CHECKBOX = 'guest_agenda_access_checkbox';
export const ADDED_GUEST_ROW = 'added_guest_row';
export const HIGHLIGHTED_ADDED_GUEST_ROW = 'highlighted_added_guest_row';
export const BULK_SELECT_ALL_CHECKBOX = 'bulk_select_all_checkbox';
export const BULK_ADD_GUEST_BUTTON = 'bulk_add_guest_button';
export const BULK_DOWNLOAD_DOCUMENTS_BUTTON = 'bulk_download_documents_button';
export const ACCESS_MANAGEMENT_USER_ROW = 'access_management_user_row';
export const ACCESS_MANAGEMENT_CHECKBOX = 'access_management_checkbox';
export const ADD_GUEST_DROPDOWN_OPTION = 'add_guest_dropdown_option';
export const EXISTING_VOTE_CONFIRMATION_CHECKBOX = 'existing_vote_confirmation_checkbox';
export const ACCESS_MANAGEMENT_USER_CLASSIFICATION_LEVEL =
    'access_management_user_classification_level';
export const AGENDA_NUMBER_INPUT = 'agenda_number_input';
export const SEND_NOTIFICATION_CHECKBOX = 'send_notification_checkbox';
export const INCLUDE_CALENDAR_INVITATION = 'include_calendar_invitation';
export const NOTIFICATION_INPUT = 'notification_input';
export const SECURITY_LEVEL = 'security_level';
export const EXTERNAL_CONTENT_POPOVER = 'external_content_popover';
export const RENAME_DOCUMENT_BUTTON = 'rename_document_button';
export const SAVE_DOCUMENT_NAME_BUTTON = 'save_document_name_button';
export const AGENDA_ITEM_SECURITY_LEVEL = 'agenda_item_security_level';
export const AGENDA_DOCUMENT_PRE_READING_BUTTON = 'agenda_document_pre_reading_button';
export const AGENDA_COMMENT_COUNT = 'agenda_comment_count';
export const DOWNLOAD_PDF_BUTTON = 'download_pdf_button';
export const DOWNLOAD_ORIGINAL_BUTTON = 'download_original_button';
export const AGENDA_ITEM_CONTENT_SKELETON = 'agenda_item_content_skeleton';
export const CONTRIBUTION_REQUEST_USER_SELECTOR = 'contribution_request_user_selector';
export const CONTRIBUTION_REQUEST_MESSAGE_INPUT = 'contribution_request_message_input';
export const AGENDA_DOCUMENT_COUNT = 'agenda_document_count';
export const AGENDA_PUBLISH_BUTTON = 'agenda_publish_button';
export const AGENDA_COMMENT_MORE_ACTIONS_MENU = 'agenda_comment_more_actions_menu';
export const COMMENTS_PANEL = 'comments_panel';

export const AGENDA_ITEM_CONTENT = 'agenda_item_content';
export const OPEN_IN_NEW_TAB_LINK = 'open_in_new_tab_link';
export const LINK_PREVIEW_IFRAME = 'link-preview-iframe';
// comments
export const MENTION_USERNAME = 'mention_username';
export const COMMENT_THREAD = 'comment_thread';

// minutes
export const HEADING_ONE_FORMATTING = 'heading_one';
export const HEADING_TWO_FORMATTING = 'heading_two';
export const HIGHLIGHT = 'highlight';
export const UNDERLINE = 'underline';
export const ALIGN_DROPDOWN = 'align_dropdown';
export const ALIGN_LEFT = 'align_left';
export const ALIGN_CENTER = 'align_center';
export const ALIGN_RIGHT = 'align_right';
export const MORE_ACTIONS = 'more_actions';
export const BOLD = 'bold';
export const ITALIC = 'italic';
export const UNDO = 'undo';
export const REDO = 'redo';
export const ORDERED_LIST = 'ordered_list';
export const UNORDERED_LIST = 'unordered_list';
export const SECTION_BREAK = 'section_break';
export const INSERT_AGENDA_ITEM_DESCRIPTION = 'insert_agenda_item_description';
export const IMAGE = 'image';

export const MINUTES_EDITOR = 'minutes_editor';
export const MINUTES_ROW = 'minutes_row';
export const MINUTES_ACTIONS_MENU = 'minutes_actions_menu';
export const PDF_LAYOUT_BUTTON = 'pdf_layout_button';
export const TASK_DECISION_ROW = 'taskdecision_row';
export const TASK_DECISION_STATUS = 'taskdecision_status';
export const TASK_FORM_NAME = 'task_form_name';
export const TASK_FORM_DESCRIPTION = 'task_form_description';
export const TASK_FORM_ASSIGNEE = 'task_form_assignee';
export const TASK_FORM_DATE = 'task_form_date';
export const TASK_FORM_SAVE = 'task_form_save';
export const TASK_NAME = 'task_name';
export const TASK_DESCRIPTION = 'task_description';
export const TASK_ASSIGNEE = 'task_assignee';
export const TASK_DATE = 'task_date';
export const TASK_STATUS = 'task_status';
export const CHANGE_STATUS_DROPDOWN = 'change_status_dropdown';
export const DECISION_FORM_DESCRIPTION = 'decision_form_description';
export const DECISION_FORM_ASSIGNEE = 'decision_form_assignee';
export const DECISION_FORM_DATE = 'decision_form_date';
export const DECISION_FORM_SAVE = 'decision_form_save';
export const DECISION_DESCRIPTION = 'decision_description';
export const DECISION_ASSIGNEE = 'decision_assignee';
export const DECISION_DATE = 'decision_date';
export const DECISION_STATUS = 'decision_status';
export const MINUTES_EDITOR_UPLOAD_IMAGE_INPUT = 'minutes_editor_upload_image_input';
export const MINUTES_EDITOR_IMAGE_CONTAINER = 'minutes_editor_image_container';
export const MINUTES_EDITOR_REMOVE_IMAGE = 'minutes_editor_remove_image';
export const MINUTES_EDITOR_RESIZE_IMAGE = 'minutes_editor_resize_image';
export const MINUTES_EDITOR_INCREASE_INDENTATION = 'minutes_editor_increase_indentation';
export const MINUTES_EDITOR_DECREASE_INDENTATION = 'minutes_editor_decrease_indentation';
export const MINUTES_ATTENDANCE_EXPAND = 'minute_attendance_expand';
export const MINUTES_ATTENDANCE_MEETING_LEADER_LABEL = 'minutes_attendance_meeting_leader_label';
export const MINUTES_ATTENDANCE_GUEST_LABEL = 'minutes_attendance_guest_label';
export const MINUTES_ATTENDANCE_EDIT_MEETING_ROLE = 'minutes_attendance_edit_meeting_role';
export const MINUTES_ATTENDANCE_MEETING_ROLE_INPUT = 'minutes_attendance_meeting_role_input';
export const MINUTES_ATTENDANCE_PARTICIPANT_ROW = 'minutes_attendance_participant_row';
export const MINUTES_MEETING_ROLE_SAVE_BUTTON = 'minutes_meeting_role_save_button';
export const MINUTES_MEETING_ROLE_CANCEL_BUTTON = 'minutes_meeting_role_cancel_button';
export const MINUTES_LAYOUT_CELL_EDITOR = 'minutes_layout_cell_editor';
export const MINUTES_LAYOUT_CELL_EDITOR_IS_SAVED = 'minutes_layout_cell_editor_is_saved';
export const MINUTES_PUBLISH_BUTTON = 'minutes_publish_button';
export const TASK_DECISION_DRAFT_STATUS_CHIP = 'task_decision_draft_status_chip';
export const TASK_DECISION_STATUS_CHIP = 'task_decision_status_chip';

export const MINUTES_VIEWERS_LIST_ROW = 'minutes_viewers_list_row';
export const MINUTES_AGENDA_ACCESS_BUTTON = 'minutes_agenda_access_button';
export const MINUTES_AGENDA_ACCESS_SEARCH = 'minutes_agenda_access_search';

export const MINUTES_SELECTOR_ROW = 'minutes_selector_row';

export const GENERATE_MINUTES_FILE = 'generate_minutes_file';

export const MINUTES_DOCUMENT_ROW = 'minutes_document_row';

export const PREPARING_DOCUMENT = 'preparing_document';

// minutes history
export const MINUTES_HISTORY_TIMELINE_TOP_LINE = 'minutes_history_timeline_top_line';
export const MINUTES_HISTORY_TIMELINE_BOTTOM_LINE = 'minutes_history_timeline_bottom_line';
export const MINUTES_HISTORY_TIMELINE_DOT = 'minutes_history_timeline_dot';
export const MINUTES_HISTORY_TIMELINE_ITEM_CARD = 'minutes_history_timeline_item_card';
export const MINUTES_HISTORY_LIST = 'minutes_history_list';
export const MINUTES_HISTORY_LIST_CLOSE = 'minutes_history_list_close';
export const MINUTES_HISTORY_DETAILS_VIEW = 'minutes_history_details_view';
export const MINUTES_HISTORY_SWITCH_DIFF_MODE = 'minutes_history_switch_diff_mode';
export const MINUTES_HISTORY_TOOLS = 'minutes_history_tools';

// meeting document download
export const DOWNLOAD_ALL_MEETING_DOCUMENTS = 'download_all_meeting_documents';
export const DOWNLOAD_ALL_MEETING_ORIGINAL_DOCUMENTS = 'download_all_meeting_original_documents';
export const DOWNLOAD_SECURED_DOCUMENTS = 'download_secured_documents';
export const DOWNLOAD_MINUTES_PDF = 'download_minutes_pdf';
export const DOWNLOAD_MINUTES_DOCX = 'download_minutes_docx';

// login
export const LOGOUT_ITEM = 'logout_item';
export const LOGIN_PASSWORD_RESET_EMAIL = 'password_reset_email';
export const PASSWORD_REQUIREMENT_ITEM = 'password_requirement_item';
export const LOGIN_USER_CHIP = 'login_user_chip';

// presenter mode
export const CANCEL_PRESENTING_CONFIRMATION = 'cancel_presenting_confirmation';
export const LEAVE_MEETING = 'leave_meeting';
export const PAUSE_PRESENTING = 'pause_presenting';
export const PRESENTATION_CONFIRMATION_FOOTER = 'presentation_confirmation_footer';
export const PRESENTER_WIDGET = 'presenter_widget';
export const START_PRESENTING = 'start_presenting';
export const START_PRESENTING_CONFIRMATION = 'start_presenting_confirmation';
export const STOP_PRESENTING = 'stop_presenting';
export const STOP_PRESENTING_CONFIRMATION = 'stop_presenting_confirmation';
export const MEETING_DETAIL_CONTAINER_RIGHT_PANEL = 'meeting_detail_container_right_panel';
export const ATTENDEE_WIDGET_BUTTON = 'attendee_widget_button';
export const ATTENDEES_LIST = 'attendees_list';
export const ATTENDEE_ROW = 'attendee_row';
export const ATTENDEE_NAME = 'attendee_name';
export const ATTENDEE_TITLE = 'attendee_title';
export const LEFT_PANEL = 'left-panel';

// tasks and decisions
export const PARTICIPANT_TAG_HELPER = 'participant_tag_helper';
export const TD_FILTER_GROUP = 'td_filter_group';
export const TD_FILTER_ASSIGNEE = 'td_filter_assignee';
export const TD_SIDE_PANEL = 'td_side_panel';
export const TD_FILTERS = 'td_filters';
export const TD_TASK_ACTIONS_TRIGGER = 'td_task_actions_trigger';
export const TD_REMARK_INPUT = 'remarks_input';
export const TD_STATUS_COLOR = 'td_status_color';
export const TD_TASK_ACTION_OPEN = 'td_task_action_open';
export const TD_TASK_ACTION_EDIT = 'td_task_action_edit';
export const TD_TASK_ACTION_REMOVE = 'td_task_action_remove';
export const TD_TASK_EDIT_STATUS_BUTTON = 'td_task_edit_status_button';
export const UNASSIGN_BUTTON = 'unassign_button';
export const TD_HISTORY_SEGMENT = 'td_history_segment';
export const TD_HISTORY_SEGMENT_LABEL = 'td_history_segment_label';
export const TD_HISTORY_SEGMENT_COMPONENT = 'td_history_segment_component';

// topic hub
export const TOPIC_ADD = 'add_new_topic';
export const TOPIC_HUB_SIDE_PANEL = 'side_panel';
export const TOPIC_HUB_FILTERS = 'topic-hub-filters';
export const TOPIC_HUB_CLASSIFICATION_LEVEL_FIELD = 'topic_hub_classification_level_field';
export const TOPIC_HUB_SCHEDULE_MODAL = 'topic_hub_schedule_modal';
export const TOPIC_HUB_COMMENTS_FILTER = 'topic_hub_comments_filter';
export const TOPIC_HUB_ROW_CHECKBOX = 'topic_hub_row_checkbox';
export const TOPIC_HUB_BULK_ACTIONS = 'topic_hub_bulk_actions';
export const TOPIC_HUB_ROW_ACTIONS_MENU = 'topic_hub_row_actions_menu';
export const TOPIC_HUB_DISCUSSION_GROUP_SELECT = 'topic_hub_discussion_group_select';
export const TOPIC_HUB_SUBMITTED_BY_GROUP_SELECT = 'topic_hub_submitted_by_group_select';
export const CLONE_TOPIC_DISCUSSION_GROUP_SELECT = 'clone_topic_discussion_group_select';
export const CLONE_TOPIC_SUBMITTED_BY_GROUP_SELECT = 'clone_topic_submitted_by_group_select';

// topic hub details

export const TOPIC_HUB_DETAILS_AGENDA_ITEM_TITLE_CLEAR =
    'topic_hub_details_agenda_item-title_clear_button';
export const TOPIC_HUB_DETAILS_TOPIC_NAME_CLEAR = 'topic_hub_details_topic_name_clear_button';
export const TOPIC_HUB_DETAILS_AGENDA_ITEM_LEADER_CLEAR =
    'topic_hub_details_item_leader_clear_button';
export const TOPIC_HUB_DETAILS_REQUESTER_USER_ROW = 'topic_hub_details_requester_user_row';

// library
export const LIBRARY_LABELS_FILTER = 'library_labels_filter';
export const LIBRARY_DRAG_DROP = 'drag_and_drop';
export const LIBRARY_CREATE_NEW_LABEL = 'library_create_new_label';
export const LIBRARY_SELECT_ALL_CHECKBOX = 'library-select-all-checkbox';
export const LIBRARY_SEND_EMAIL_LIST = 'library_send_email_list';
export const LIBRARY_FILTERS = 'library_filters';
export const LIBRARY_ROW_MORE_ACTIONS_MENU_OPTIONS = 'library_row_more_actions_menu_options';
export const LIBRARY_SECURITY_ICON = 'security_icon_level';
export const DOCUMENT_FAVORITE_REMOVE = 'document_favorite_remove';
export const DOCUMENT_MARK_AS_UNREAD = 'document_mark_as_unread';

// meetingOverview
export const MEETING_LIST_TIMEFRAME_SELECT = 'timeframe_select';
export const MEETING_LIST_ROW = 'meeting_list_row';
export const MEETING_LIST_ROW_NAME = 'meeting_list_row_name';
export const MEETING_LIST_ROW_LOCK_ICON = 'meeting_list_row_lock_icon';
export const MEETINGS_LIST_SEPARATOR = 'meetings_list_separator_header';
export const MEETINGS_LIST_SECTION_HEADER = 'meetings_list_section_header';
export const EDITOR_MEETING_LEADER_TOGGLE = 'editor_meeting_leader_toggle';
export const MEETINGS_ADD = 'add_new_meeting';
export const MEETINGS_SELECT_PHYSICAL = 'physical_meeting';
export const MEETINGS_SELECT_DCR = 'circular_resolution_meeting';
export const OPEN_VISIBILITY_MODAL_BUTTON = 'open_visibility_modal_button';
export const SELECTABLE_PARTICIPANT_ROW = 'selectable_participant_row';
export const SELECTABLE_GROUP_ROW = 'selectable_group_row';
export const SUMMARY_PARTICIPANT_ROW = 'summary_participant_row';
export const NEXT_MEETING_LIST_ROW = 'next_meeting_list_row';
export const NEW_MEETING_BUTTON = 'new_meeting_button';
export const NEXT_MEETING_BUTTON = 'next_meeting_button';
export const NEXT_MEETING_PILL = 'next_meeting_pill';
export const ONGOING_MEETING_PILL = 'ongoing_meeting_pill';
export const MEETING_OVERVIEW_FILTERS = 'meeting_overview_filters';
export const MEETING_OVERVIEW_GROUPS_FILTER = 'meeting_overview_groups_filter';
export const MEETING_OVERVIEW_PUBLISHING_STATUS_FILTER =
    'meeting_overview_publishing_status_filter';
export const MEETING_OVERVIEW_PARTICIPANTS_FILTER = 'meeting_overview_participants_filter';
export const MEETING_ALLOCATE_SECTION_MENU_TRIGGER = 'meeting_allocate_section_menu_trigger';

// meetingOverview participant view
export const APPROVE_AGENDA = 'approve-agenda';
export const APPROVE_MINUTES = 'approve-minutes';
export const OPEN_AGENDA_APPROVAL = 'open-agenda-approval';
export const OPEN_MINUTES_APPROVAL = 'open-minutes-approval';
export const PARTICIPANT_ROW = 'participant_row';
export const NEXT_MEETING_CARD = 'next_meeting_card';
export const MEETING_OVERVIEW_FILTER_ITEM = 'meeting_overview_filter_item';
export const MEETING_PREPAREDNESS = 'meeting_preparedness';
export const TODAY_PLACEMENT = 'today_placement';
export const MEETING_FEEDBACK_CUSTOM = 'meeting_feedback_custom';
export const MEETING_TIME = 'meeting_time';
export const PARTIAL_MEETING_TIME = 'partial_meeting_time';
export const UPLOAD_DOCUMENTS_BUTTON = 'upload_documents_button';
export const UPLOAD_CONTRIBUTION_REQUEST_BUTTON = 'upload_contribution_request_button';
export const REMOVE_UN_UPLOADED_CONTRIBUTION_REQUEST = 'remove_un_uploaded_contribution_request';
export const DOCUMENT_FILTER_ITEM_NAME = 'document_filter_item_name';
export const TODOS_LIST = 'todos_list';
export const PREPAREDNESS_LOADING_SKELETON = 'preparedness_loading_skeleton';
export const EMPTY_TODOS_EMPTY_MEETINGS = 'empty_todos_empty_meetings';
export const EMPTY_TODOS_WITH_MEETINGS = 'empty_todos_with_meetings';
export const NOTE_ANNOTATION_TEXTAREA = 'note-annotation-textarea';
export const AGENDA_ITEM_COLLAPSABLE_ITEM = 'agenda_item_collapsable_item';
export const AGENDA_ITEM_VISIBLE_SECTION = 'agenda_item_visible_section';

// document upload
export const FOLDER_ROW = 'folder-row';
export const DOCUMENT_ROW = 'document-row';
export const DOCUMENT_UPLOAD_CANCEL = 'document_upload_cancel';
export const DOCUMENT_UPLOAD_ADD = 'document_upload_add';
export const DOCUMENT_UPLOAD_TAB_UPLOAD = 'tab_upload';
export const DOCUMENT_UPLOAD_TAB_UNALLOCATED = 'tab_unallocated';
export const DOCUMENT_UPLOAD_LIST = 'upload_documents_list';
export const DOCUMENT_UPLOAD_DROPZONE = 'upload_document_dropzone';
export const DOCUMENT_UPLOAD_DROPZONE_BUTTON = 'upload_document_dropzone_button';
export const DOCUMENT_UPLOAD_DROPZONE_HINT = 'upload_document_dropzone_hint';
export const DOCUMENT_REMOVE_FROM_LIST = 'document_remove';
export const DOCUMENT_UPLOAD_STATUS_CHECKMARK = 'upload_status_check_mark';
export const PROGRESS_BAR_DESCRIPTION = 'progress_bar_description';
export const UPLOAD_DOCUMENT_ICON = 'upload_document_icon';
export const UPLOAD_DOCUMENT_NAME = 'upload_document_name';
export const UPLOADED_DOCUMENT_ROW = 'uploaded_document_row';

// UI elements
export const SELECT_WITH_EDIT_OPTION = 'select_with_edit_option';
export const SKELETON_LOADING = 'skeleton_loading';
export const EDITOR_DIFF_ADDED_TEXT = 'editor_diff_added_text';
export const EDITOR_DIFF_REMOVED_TEXT = 'editor_diff_removed_text';
export const EDITOR_DIFF_UNCHANGED_TEXT = 'editor_diff_unchanged_text';

// global search
export const SEARCH_RESULT_ROW_TITLE = (type: SearchResultType, title: string) =>
    `search_result_${type}: ${title}`;
export const GLOBAL_SEARCH_BUTTON = 'global_search_button';
export const GLOBAL_SEARCH_FILTERS = 'global_search_filters';
export const GLOBAL_SEARCH_FILTERS_CHIPS = 'global_search_filters_chips';
export const GLOBAL_SEARCH_ROOM_FILTER = 'global_search_room_filter';
export const GLOBAL_SEARCH_GROUP_FILTER = 'global_search_group_filter';
export const GLOBAL_SEARCH_LABEL_FILTER = 'global_search_label_filter';
export const GLOBAL_SEARCH_RESULT_ITEM = 'global_search_result_item';
export const GLOBAL_SEARCH_OPEN_NEW_TAB = 'global_search_open_new_tab';
export const GLOBAL_SEARCH_STATUS_FILTER = 'global_search_status_filter';
export const GLOBAL_SEARCH_MINUTES_TYPE_FILTER = 'global_search_minutes_type_filter';
export const GLOBAL_SEARCH_RESULTS = 'global-search-results';

// form control
export const FORM_CONTROL_CLEAR_BUTTON = 'form_control_clear_button';
export const CALENDAR_ICON = 'calendar_icon';

// send email notification
export const EMAIL_SUBJECT = 'email_subject';
export const EMAIL_MESSAGE = 'email_message';

// access overview
export const SHOW_DOCUMENTS_TOGGLE = 'show_documents_toggle';
export const ACCESS_OVERVIEW_ITEM_NUMBER = 'access_overview_item_number';
export const ACCESS_OVERVIEW_ACCESS_INDICATOR = 'access_overview_access_indicator';
export const ACCESS_OVERVIEW_ORGANISATIONAL_ITEM_NUMBER =
    'access_overview_organisational_item_number';
export const ACCESS_OVERVIEW_MEMBER_LIST = 'access_overview_member_list';

// forms
export const FILTER_NAME_FIELD = 'filter_name_field';
export const FILTER_STATE_SELECTOR = 'filter_state_selector';
export const NEW_FORM_BUTTON = 'new_form_button';
export const FORM_NAME_FIELD = 'form_name_field';
export const FORM_RESPONDENTS_FIELD = 'form_respondents_field';
export const NEW_FORM_NEXT_BUTTON = 'new_form_next_button';
export const NEW_FORM_CREATE_BUTTON = 'new_form_create_button';
export const FORM_RESPONDENTS_BUTTON = 'form_respondents_button';
export const DOWNLOAD_FORM_XLSX_BUTTON = 'download_form_xlsx_button';
export const COPY_FORM_LINK_BUTTON = 'copy_form_link_button';
export const DELETE_FORM_BUTTON = 'delete_form_button';
export const EVALUATION_FIELD_CONTAINER = 'evaluation_field_container';
export const EVALUATION_FIELD = 'evaluation_field';
export const READ_ONLY_EVALUATION_FIELD = 'readonly_evaluation_field';
export const FORM_LIST_ROW = 'form_list_row';
export const SEND_FORM = 'send_form';
export const QUESTION_ANSWERED = 'question_answered';
export const QUESTION_UNANSWERED = 'question_unanswered';
export const LEAVE_FORM_BUTTON = 'leave_form_button';
export const FORM_FILTER_OPTION = 'form_filter_option';
export const FORM_FILTERS = 'form_filters';

// room settings
export const OPEN_ROOM_SETTINGS_BUTTON = 'open_room_settings_button';
export const SAVE_ROOM_SETTINGS_BUTTON = 'save_room_settings_button';
export const CANCEL_ROOM_SETTINGS_BUTTON = 'cancel_room_settings_button';
export const MEETING_FEEDBACK_SETTING_TOGGLE = 'meeting_feedback_setting_toggle';
export const AGENDA_ITEM_DURATION_ROOM_SETTING_SELECTOR =
    'agenda_item_duration_room_setting_selector';
export const DOCUMENT_SECURITY_BUTTON = 'document_security_button';
export const SHARING_PREPAREDNESS_LEVEL_BUTTON = 'sharing_preparedness_level_button';
export const CUSTOM_INVITATION_BUTTON = 'custom_invitation_button';
export const MEETING_FEEDBACK_FORM_BUTTON = 'meeting_feedback_form_button';
export const CONFERENCE_CALL_BUTTON = 'conference_call_button';
export const AGENDA_ITEM_DURATION_BUTTON = 'agenda_item_duration_button';
export const COVER_PAGE_TOGGLE = 'cover_page_toggle';
export const AGENDA_PAGE_TOGGLE = 'agenda_page_toggle';

// custom invitation settings
export const CUSTOM_INVITATION_SETTINGS_BUTTON = 'custom_invitation_settings_button';
export const CUSTOM_INVITATION_FULLSCREEN_BUTTON = 'custom_invitation_fullscreen_button';

// home module
export const VIEW_IN_MEETING_LIST = 'view_in_meeting_list';
export const UPCOMING_MEETINGS_INFO = 'upcoming_meetings_info';
export const TODO_LIST_HIDE_PAST_MEETINGS = 'todo_list_hide_past_meetings';
export const TODO_LIST_ROW = 'todo_list_row';
export const TODO_GROUP_DISMISS_BUTTON = 'todo_group_dismiss_button';

export const RICH_EDITOR_FILE_UPLOAD_INPUT = 'rich_editor_file_upload_input';
export const FILTERS_BUTTON = 'filter-toggle-button';
